<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import VueTurnstile from 'vue-turnstile';
import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { getTurnTile } from '@/api/auth';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

const { status } = storeToRefs(useUserStore());
const { login } = useUserStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();

const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

const isSubmitting = ref(false);
const siteKey = ref('0x4AAAAAAAZqJH--lkL6CG4V');
const activeValidation = ref(false);
const token: any = ref(undefined);

const validate = computed(() => {
    return yup.object({
        email: yup.string().required().email(),
        password: yup.string().required()
    });
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [email, password] = useFieldModel(['email', 'password']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    if(!token){ return; }
    isSubmitting.value = true;
    emit('onSubmit', true);
    const error = await login(values.email, values.password, token.value);
    emit('onSubmit', false);
    const prevRoute = router.options.history.state.back;
    activeValidation.value = false;
    isSubmitting.value = false;
    if (error) {
        resetForm();

        openMessage({
            content: 'modals.alerts.errorSubmitLoginForm',
            class: 'error'
        });
    } else {
        resetForm();

        openMessage({
            content: 'modals.alerts.successSubmitLoginForm',
            class: 'success'
        });

        // Reset token after success login
        token.value = undefined;
        
        //change to credits by default on login
        useUserStore().changePaymentMethod('credits');

        if (props.page) {
            if (prevRoute?.includes('profile')) {
                router.push({ path: prevRoute.toString() })
            } else {
                router.push({ name: 'grid' });
            }
        } else {
            closeModal('login');
        }
    }
});

function doLostPassword() {
    // TODO: refactor to store
    if (props.page) {
        router.push({ name: 'lostpassword' });
    } else {
        toggleModal('lostpassword');
    }
}

function doRegister() {
    // TODO: refactor to store
    if (props.page) {
        router.push({ name: 'register' });
    } else {
        toggleModal('register');
    }
}
</script>

<template src="./modal-login.html"></template>
